import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { FloatingActions } from './FloatingActions';

export function PublicLayout() {
  return (
    <div
      style={{
        backgroundImage: "url('/careers_bg.png')",
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <Navbar />
      <Outlet />
      <Footer />
      <FloatingActions />
    </div>
  );
}







